export const FEEDBACK_ROLE = 'feedback.bearbeiter'
